/**
 * 权限检查工具
 */

/**
 * 检查用户是否有指定权限
 * @param {string} permKey 权限键，如 'view_bill'
 * @returns {boolean}
 */
export function hasPermission(permKey) {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  
  // 不是子账号，有全部权限
  if (!userInfo.parent_id) {
    return true
  }
  
  // 是子账号，检查permissions
  const permissions = userInfo.permissions || {}
  return permissions[permKey] === true
}

/**
 * 获取用户所有权限
 * @returns {object}
 */
export function getUserPermissions() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  
  if (!userInfo.parent_id) {
    // 不是子账号，返回全部权限
    return {
      view_bill: true,
      download_bill: true,
      send_bill: true,
      view_customer: true,
      manage_customer: true,
      view_linker: true,
      manage_linker: true,
      view_stats: true,
      manage_subaccount: true
    }
  }
  
  return userInfo.permissions || {}
}

/**
 * 检查是否是子账号
 * @returns {boolean}
 */
export function isSubAccount() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
  return !!userInfo.parent_id
}
